import React, { useEffect, useState } from 'react';
import { Box, Link, Stack } from '@mui/material';
import AdminNavbarLinks from 'dashboard/components/navbar/NavbarLinksAdmin';
import { BAR_HEIGHT, CHROME_TOP } from 'dashboard/layouts/admin/chromeGeometry';

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const {
    secondary,
    mini,
    setMini,
    theme,
    setTheme,
    authentication,
    componentsOrder = [],
  } = props;

  useEffect(() => {
    const changeNavbar = () => setScrolled(window.scrollY > 1);
    window.addEventListener('scroll', changeNavbar);
    return () => window.removeEventListener('scroll', changeNavbar);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        // Only as wide as the account cluster: the rest of this line belongs
        // to the section's bar, which is part of the content region below it.
        display: secondary ? 'block' : 'flex',
        justifyContent: { xl: 'center' },
        zIndex: 30,
        height: `${BAR_HEIGHT}px`,
        // Top of the band, not the middle of it. The page's panel starts where
        // this band ends and passes underneath the pill, so centring the pill
        // splits the spare height into a gap above it — where nothing is — and
        // half a gap below, where the panel is. See ACCOUNT_CLEARANCE.
        alignItems: 'flex-start',
        right: authentication ? 0 : { xs: '12px', md: '30px' },
        left: authentication ? 0 : 'auto',
        top: { xs: `${CHROME_TOP.xs}px`, md: `${CHROME_TOP.md}px` },
        transition: 'box-shadow 0.25s',
        boxShadow: scrolled ? '0 4px 16px rgba(0,0,0,0.04)' : 'none',
        borderRadius: '999px',
      }}
    >
      <Stack
        direction='row'
        width='100%'
        alignItems={{ xl: 'center' }}
      >
        {!authentication ? (
          <Box sx={{ ml: 'auto', width: { xs: '100%', md: 'auto' } }}>
            <AdminNavbarLinks
              mini={mini}
              setMini={setMini}
              theme={theme}
              setTheme={setTheme}
              secondary={secondary}
              {...props}
            />
          </Box>
        ) : (
          <Stack direction='row' spacing='10px' alignItems='center'>
            <Box component='img' src='/assets/images/logo/logo.svg' alt='Logo' sx={{ height: '35px' }} />
            <Link href='/' color='primary' fontWeight={500} underline='hover'>HOME</Link>
            {componentsOrder.map((component) => (
              <Link key={component} href={`/#${component}`} color='primary' fontWeight={500} underline='hover'>
                {component}
              </Link>
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
